import {useContext, useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';
import {globalUIContext} from '../../utils/global-ui-helpers';
import {HELP_AND_SUPPORT_MODAL} from '../../constants/modals';
import HelpAndSupportModal from './help-and-support-modal';
import './index.less';
import FocusTrap from 'focus-trap-react';

const getModal = (modal, closeModal, isMobile, initialFocus) => {
  switch (modal?.modalName) {
    case HELP_AND_SUPPORT_MODAL:
      return (
        <HelpAndSupportModal
          {...modal?.modalProps}
          handleClose={closeModal}
          isMobile={isMobile}
          initialFocus={initialFocus}
        />
      );
    default:
      return null;
  }
};

const Modal = () => {
  const {modal, closeModal, isMobile} = useContext(globalUIContext);
  const initialFocus = useRef();
  useEffect(() => {
    if (modal?.modalProps?.canClose) {
      const closeOnEscapeKey = (e) =>
        e.key === 'Escape' ? closeModal() : null;
      document.body.addEventListener('keydown', closeOnEscapeKey);
      return () => {
        document.body.removeEventListener('keydown', closeOnEscapeKey);
      };
    }
  }, [modal, closeModal]);

  const selectedModal = getModal(modal, closeModal, isMobile, initialFocus);
  return (
    selectedModal &&
    createPortal(
      <div className="earth-portal-modal">
        <div
          className="earth-portal-modal__backdrop"
          onClick={() => modal?.modalProps?.canClose && closeModal()}
        ></div>
        <FocusTrap
          focusTrapOptions={{initialFocus: () => initialFocus.current}}
        >
          <div className="earth-portal-modal__container">{selectedModal}</div>
        </FocusTrap>
      </div>,
      document.body
    )
  );
};

export default Modal;
